import PropTypes from "prop-types";

import React, { useEffect, useState } from "react";

import logolight from "../../assets/images/quess_360_solutions-pharmacies.png";
import logodark from "../../assets/images/quess_360_solutions-pharmacies.png";

import withRouter from "../../components/Common/withRouter";
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useNavigate ,useParams} from 'react-router-dom';
import logoEnDark from "../../assets/images/QUESS.ENG.Couleur.png";
import axios from "axios";
import { BACKEND_URL_PORTAIL } from "../../config/const.js";
import './style.css'

const DoubleAuthentication = () => {
 
  const {t} = useTranslation();
  document.title = t('doubleAuthentication');
  const { language } = useParams();
  const history = useNavigate ();

  const [lang,setLang]= useState(localStorage.getItem('lang'))
  const [code,setCode]= useState("")
  const [userId,setUserId]= useState()
  const [error,setError]= useState("")
  const [emailSentResult, setEmailSentResult] = useState(null);
  const [resendMail, setResendMail] = useState(null);
  const [deactivateMFA, setDeactivateMFA] = useState(false);
  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };
  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const response = await axios.get(`${BACKEND_URL_PORTAIL}api/connectedUserInfo`, config);
       
        
        setUserId(response.id)
     
      } catch (error) {
        console.error("Error fetching profile data:", error.response ? error.response : error.message);
     
      }
    };

    fetchUserProfile();
  }, []); // Empty array to fetch data only on component mount
  const changeLanguage=(val)=> { 
    const langUrl = localStorage.getItem("lang");
    if(language=="fr"||language=="en"){
     
      if (val !== langUrl) {
        localStorage.setItem("lang", val);
        setLang(val);
        history.push("/"+val)
        window.location.reload();
      }else{
        window.location.reload();
      }
    } else{
      
      localStorage.setItem("lang",val);
      setLang(val);
      window.location.reload();
    } 
  }
  const  loginMFA= async ()=>{
    setEmailSentResult(null);
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'X-MFA-Token': `${localStorage.getItem('SET_TEMP_TOKEN')}`,
      },
    };
    const userData={
      userId :userId,
      verificationcode:code,
      deactivateMFA:deactivateMFA
    }

   
    try {
       const response = await axios.post(`${BACKEND_URL_PORTAIL}api/login2FA`, userData, config);
      if (response.isVerified) {
      setEmailSentResult({ text: t("loginSuccess"), type: "success" });
       localStorage.setItem("authUser", JSON.stringify(response.token));
        localStorage.setItem("token", response.token);
      
           
             handlePostLoginTasks(response.token) ;
  
      setTimeout(() => {
      
         window.location="/home"
      }, 2500);
    } else {
      setEmailSentResult({ text: t("errorLogin"), type: "error" });
      setTimeout(() => {
        setEmailSentResult(null);
      }, 2500);
    }
      
    } catch (error) {
      setEmailSentResult({ text: t("errorLogin"), type: "error" });
      setTimeout(() => {
        setEmailSentResult(null);
      }, 2500);
    }
    
   
  }
  async function handlePostLoginTasks(token) {
  try {
    const config = { 
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    
    // Example: Fetch user profile data
    const userInfo = await axios.get(BACKEND_URL_PORTAIL + "api/getUserInfos",config);
    //yield put(setUserProfile(userProfile));
    localStorage.setItem('idUser', userInfo.userInfo.Id);
    localStorage.setItem('username', userInfo.userInfo.UserName);
  
    // Add any other functions you want to call after a successful login
  } catch (error) {
    console.log('Post-login tasks failed:', error);
    // Handle any errors in the additional tasks
  }
}

  const resendMail2A = event => {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'X-MFA-Token': localStorage.getItem('SET_TEMP_TOKEN'), 
      },
    };
    const data2FA = {
      mode: 'mail',
      lang: localStorage.getItem('lang')?localStorage.getItem('lang'):"en"
    };
    axios.post(BACKEND_URL_PORTAIL + 'api/sendCode2FA', data2FA, config)
      .then(response => {
        setResendMail({ text: t("emailSent"), type: "success" });
      setTimeout(() => {
        setResendMail(null);
        
      }, 2500);
      }).catch((error) => {
        setResendMail({ text: t("emailSentError"), type: "error" });
        setTimeout(() => {
          setResendMail(null);
        }, 2500);
      });
  };
  return (
    <React.Fragment>
      <div className="bg-pattern" style={{ height: "100vh" }}>
        <div className="bg-overlay "></div>
        <div className="account-pages pt-5">
          <Container>
            <Row className="justify-content-center">
              <Col lg={10} md={10} xl={8}>
                <Card className='mt-5'>
                  <CardBody className="p-4">
                    <div className="">
                      <div className="text-center">
                        <Link to="/" className="">
                          <img src={lang=="fr"?logodark:logoEnDark} alt="" height="24" className="auth-logo logo-dark mx-auto" />
                          <img src={logolight} alt="" height="24" className="auth-logo logo-light mx-auto" />
                        </Link>
                      </div>
                      <h4 className="font-size-48 mt-3 text-center" style={{color:"#6bb3e5"}}>{t('doubleAuthentication')}</h4>
                      <section className="jss109">
                      
                      </section>
                      {/* <p className="mb-5 text-center"></p> */}
                  <section className="jss109">
                      <hr className="jss150" data-content={t('2faTxt')} style={{ margin: "50px 4px 10px" }} />
                    </section>
                
                        <Row>
                          <Col md={4}></Col>
                          <Col md={4}>
                          

                            <div className="mt-2" style={{alignItems:'center'}}>
                              {/* <label className="form-label" htmlFor="code" style={{textAlign:'center'}}>Code</label> */}
                              <input
                                type="text"
                                //inputMode="numeric"
                                //pattern="\d*"
                                className="form-control"
                                id="code"
                                placeholder={t('verifCode')}
                                maxLength="6"
                              
                                onChange={(e) => {
                                 // const onlyNums = e.target.value.replace(/\D/g, '');
                                  setCode(e.target.value);
                                }}
                                value={code}
                              />
                            </div>
                            <div className="d-grid mt-4">
                              <Row className="mt-3">
                                      
                                      <Col lg={2}>
                                              <div className="form-check">
                                                <input
                                                  name="deactivateMFA"
                                                  className="form-check-input"
                                                  type="checkbox"
                                                  checked={deactivateMFA}
                                                  onClick={() => setDeactivateMFA(!deactivateMFA)}
                                                />    
                                              </div>
                                      </Col>
                                      <Col lg={10}>
                                          <label className="form-label">
                                                   {t("deactivateMFA")}
                                          </label>
                                      </Col>
                                 </Row>
                            </div>
                            <div className="d-grid mt-4">
                              <button  className="btn btn-primary waves-effect waves-light" onClick={()=>{loginMFA()}}>{t('sendCode')}<i className="mdi mdi-arrow-right" /></button >
                            </div>
                            <div className="d-grid mt-4">
                              <button 
                                className="btn btn-secondary border colorButton"
                                onClick={()=>{resendMail2A()}}                              >
                                {t('resendMail')}
                                <i className="mdi mdi-refresh"></i>
                              </button>
                            </div>
                            {/* <div  className="lngBtn" style={{display:'flex',alignItems:'center', justifyContent:'center', marginTop:"5%"}}> 
                              <div  style={{  color: '#039be5', textAlign:'center'}}  >
                                <button id="fr" onClick={()=>changeLanguage("fr")}        
                                style={{  borderBottom: localStorage.getItem('lang') === 'fr' ? 'solid #32a1ce' : 'initial', borderRadius:'0'
                                ,color: '#039be5'}}
                                  className="btn  waves-effect waves-light"
                                >{t("francais")}
                                </button>
                                /
                                <button  id="en"
                                style={{ borderBottom: localStorage.getItem('lang') === 'en' ? 'solid #32a1ce' : 'initial', borderRadius:'0'
                                ,color: '#039be5'}}
                                onClick={()=>changeLanguage("en")}   className="btn  waves-effect waves-light">{t("anglais")}
                                
                                </button>
                              </div>
                              <i className="bx bx-globe" style={{ fontSize: '25px' }} />
                            

                            </div> */}
                          </Col>
                          <Col md={4}></Col>
                        </Row>
                    
                    </div>
                  </CardBody>
                </Card>
                <div className="mt-5 text-center">
                       <p className="text-white-50">© QUESS 360 - {t("SP")} {new Date().getFullYear()}</p>
                </div>
              </Col>
            </Row>
          </Container>
          {emailSentResult && (
            <div
              style={{
                position: "fixed",
                bottom: "10px",
                left: "50%",
                transform: "translateX(-50%)",
                padding: "10px 20px",
                backgroundColor:
                  emailSentResult.type === "success" ? "green" : "#ff3d60",
                color: "white",
                borderRadius: "5px",
                zIndex: 1000,
                minWidth: "25%",
                textAlign: "center",
                transition: "opacity 0.5s ease-in-out",
              }}
            >
              {emailSentResult.text}
            </div>
          )}
          {resendMail && (
            <div
              style={{
                position: "fixed",
                bottom: "10px",
                left: "50%",
                transform: "translateX(-50%)",
                padding: "10px 20px",
                backgroundColor:
                resendMail.type === "success" ? "green" : "#ff3d60",
                color: "white",
                borderRadius: "5px",
                zIndex: 1000,
                minWidth: "25%",
                textAlign: "center",
                transition: "opacity 0.5s ease-in-out",
              }}
            >
              {resendMail.text}
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
}
export default withRouter(DoubleAuthentication);

DoubleAuthentication.propTypes = {
  history: PropTypes.object,
};
